













import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { BuildingsApi, Room } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    buildingsApi: 'buildingsApi'
  })
})
export default class Location2DisplayComponent extends Vue {
  @Prop({ required: false, default: 'Room' })
  private label!: string;

  @Prop({ required: true, type: String })
  private buildingCode!: string;

  @Prop({ required: true, type: String })
  private roomCode!: string;

  private buildingsApi!: BuildingsApi;

  private room: Room | undefined;

  data() {
    return {
      room: undefined
    };
  }

  private mounted() {
    this.room = undefined;
    if (this.roomCode) {
      this.loadBuildingDetails(this.roomCode);
    }
  }

  @Watch('roomCode')
  buildingCodeWatcher(val: string) {
    this.room = undefined;
    this.loadBuildingDetails(val);
  }

  loadBuildingDetails(val: string) {
    // do a one-off building query and try that
    this.buildingsApi
      .queryRooms({ buildingCode: this.buildingCode, roomCode: val })
      .then((rooms) => {
        if (rooms && rooms.data) {
          const match = rooms.data.find((r) => r.roomCode === val);
          if (match) {
            this.room = match;
          }
        }
      })
      .catch(() => {
        /**? */
      });
  }
}
